/* eslint-disable tailwindcss/no-custom-classname */

import {
  Tag as ChakraTag,
  TagProps as ChakraTagProps,
  ThemingProps,
  forwardRef,
} from '@chakra-ui/react';
import classnames from 'classnames';
import React, { cloneElement, isValidElement } from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';
import { TagCloseButton } from '../TagCloseButton/TagCloseButton';

import { TagColorScheme } from './shared';

export interface TagProps
  extends OmitChakraProps<ChakraTagProps, keyof ThemingProps> {
  icon?: React.ReactNode;
  colorScheme?: TagColorScheme;
  onClose?: () => void;
}

export const Tag = forwardRef<TagProps, 'span'>(
  ({ colorScheme = 'blue', children, icon, onClose, ...props }, ref) => {
    return (
      <ChakraTag {...props} ref={ref} colorScheme={colorScheme} variant="solid">
        {isValidElement(icon) &&
          cloneElement(icon, {
            className: classnames(icon.props.className, 'tag-icon'),
          } as { className?: string })}
        {children}
        <TagCloseButton onClick={onClose} />
      </ChakraTag>
    );
  },
);
